import React from 'react';
import { connect } from 'react-redux';
import { MAPS, TILES_DATA, TILES_SPRITESHEET_DIMS } from "../Helpers/maps";

// Migrated off @emotion/react to plain inline styles. Emotion's
// stylesheet GC was suspected of racing React 18's concurrent unmount
// during the ONGOING → FIGHT transition (Map unmounts at that point),
// producing "removeChild: not a child of this node". Plain inline
// styles eliminate that vector entirely.
class Map extends React.Component {
    render() {
        const { elementStyle: { width = '64px', height = '64px' }, mapId = 'map1', iconPosition } = this.props;

        const mapData = MAPS[mapId] || Object.values(MAPS)[0];
        const { rows, columns } = mapData;

        const cellSize = parseInt(width);
        const left = (iconPosition?.x || 0) * cellSize + (cellSize / 2) - 16;
        const top = (iconPosition?.y || 0) * cellSize + (cellSize / 2) - 16;

        const mainContainerStyle = {
            display: 'grid',
            position: 'relative',
            gridTemplateRows: `repeat(${rows}, ${width})`,
            gridTemplateColumns: `repeat(${columns}, ${width})`,
            backgroundColor: '#444',
        };

        return (
            <div style={CONTAINER_STYLE}>
                <div style={MAP_WRAPPER_STYLE}>
                    <div style={mainContainerStyle}>
                        {this.displayGrid()}
                        <div
                            style={{
                                ...HERO_ELEMENT_STYLE,
                                transform: `translate(${left}px, ${top}px)`,
                            }}
                        >
                            🏹
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    displayGrid() {
        const { elementStyle: { width = '64px', height = '64px' }, mapId = 'map1' } = this.props;
        const mapData = MAPS[mapId] || Object.values(MAPS)[0];

        if (!mapData?.grid) return null;

        return mapData.grid.flatMap((row, y) =>
            row.map((zoneType, x) => {
                const tile = zoneType ? TILES_DATA[zoneType] : null;
                const tileStyle = tile ? {
                    backgroundImage: `url(${tile.texture})`,
                    backgroundPosition: `${tile.rectX * tile.baseScale}px ${tile.rectY * tile.baseScale}px`,
                    backgroundSize: `${TILES_SPRITESHEET_DIMS.width * tile.baseScale}px ${TILES_SPRITESHEET_DIMS.height * tile.baseScale}px`,
                    backgroundRepeat: 'no-repeat',
                    imageRendering: 'pixelated',
                } : {};

                return (
                    <div
                        key={`${x}-${y}`}
                        data-x={x}
                        data-y={y}
                        style={{
                            ...GRID_ELEMENT_STYLE,
                            width,
                            height,
                            ...tileStyle,
                        }}
                    />
                );
            })
        );
    }
}

export default connect()(Map);

const CONTAINER_STYLE = {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
};

const MAP_WRAPPER_STYLE = {
    position: 'relative',
    border: '2px solid #555',
    backgroundColor: '#333',
    overflow: 'hidden',
    boxShadow: '0 0 15px rgba(0,0,0,0.5)',
};

const GRID_ELEMENT_STYLE = {
    position: 'relative',
    background: '#444',
    border: '1px solid #555',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFF',
};

const HERO_ELEMENT_STYLE = {
    position: 'absolute',
    width: '32px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '24px',
    zIndex: 10,
    pointerEvents: 'none',
    userSelect: 'none',
    textShadow: '0 0 5px rgba(0,0,0,0.5)',
    opacity: 1,
    transform: 'translate(0, 0)',
    transition: 'transform 0.3s ease',
    willChange: 'transform',
};